import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { Helmet } from "react-helmet";
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
    FacebookShareButton, TwitterShareButton, WhatsappShareButton, LinkedinShareButton, TelegramShareButton,
    FacebookIcon, TwitterIcon, LinkedinIcon, WhatsappIcon, TelegramIcon
} from 'react-share';
import Gallery from 'react-grid-gallery';
import StarRatingComponent from 'react-star-rating-component';
import dateFormator from '../utility/dateFormator';
import MapContainer from '../Map/MapContainer';
import styles from './forms/addpost.module.css';
import { Labels } from '../UIElements/ContentPost_Label/Labels';
import { LinkButton } from '../UIElements/Link_Button/LinkButton';
import VisibilitySensor from 'react-visibility-sensor';
import { useViewportBillBoard } from '../utility/useViewport';
import MetaDecor from "../MetaDecor"
import { useViewport } from '../utility/useViewport';
import moment from 'moment';
import { Link } from 'react-router-dom/cjs/react-router-dom';

export const PostContent = (props) => {

    const [listing] = useState(props.listing);
    const [editorState, setEditorState] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [mapVisible, setMapVisible] = useState(false);
    const videoRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const textAreaRef = useRef(null);
    const isBillboard = useViewportBillBoard();
    const [copied, setCopied] = useState(false);
    const shareUrl = String(window.location.href)
    const isMobile = useViewport()
    const content_page = useSelector(state => state.content_page)
    //console.log(props)
    useEffect(() => {
        if (listing.listingType === "article") {
            if (!isVisible) {
                if (videoRef.current.play) {
                    videoRef.current.pause();
                }
            }
        }
    }, [isVisible]);

    useEffect(() => {
        if (props.videoPause) {
            console.log('trying to pause video')
            videoRef.current.pause()
        }
    }, [props]);

    
    useEffect(() => {
        const video = videoRef.current;
        
        if (video) {
          // Disable Picture-in-Picture
          video.disablePictureInPicture = true;
    
          // Prevent PiP mode
          video.addEventListener("enterpictureinpicture", (event) => {
            event.preventDefault();
            document.exitPictureInPicture();
          });
    
          // Safari-specific fix
          video.addEventListener("webkitpresentationmodechanged", () => {
            if (video.webkitPresentationMode === "picture-in-picture") {
              video.webkitSetPresentationMode("inline");
            }
          });
    
          // Prevent Playback Speed Change
          video.playbackRate = 1; // Set default speed
          video.addEventListener("ratechange", () => {
            video.playbackRate = 1; // Force speed back to normal
          });
        }
    
        return () => {
          if (video) {
            video.removeEventListener("enterpictureinpicture", () => {});
            video.removeEventListener("webkitpresentationmodechanged", () => {});
            video.removeEventListener("ratechange", () => {});
          }
        };
      }, []);

    useEffect(() => {
        const comparator = {
            "Monday": 1,
            "Tuesday": 2,
            "Wednesday": 3,
            "Thursday": 4,
            "Friday": 5,
            "Saturday": 6,
            "Sunday": 7
        }
        listing.openingHoursList.sort((a, b) => {
            return comparator[a.day] - comparator[b.day];
        });

        if (listing.businessPackage === 'premium' || listing.businessPackage === 'advanced') {
            if (listing.specializedIn) {
                const con = JSON.parse(listing.specializedIn)
                const contentState = convertFromRaw(con);
                setEditorState(EditorState.createWithContent(contentState))
            }
            if (listing.advance_content) {
                const con = JSON.parse(listing.advance_content)
                const contentState = convertFromRaw(con);
                setEditorState(EditorState.createWithContent(contentState))
            }
            // if (listing.galleryImages.length) {
            //     let gallery = listing.galleryImages.map(image => {
            //         return {
            //             src: process.env.REACT_APP_IMAGES_URL + image.imageName,
            //             thumbnail: process.env.REACT_APP_IMAGES_URL + image.imageName,
            //             thumbnailWidth: 135,
            //             thumbnailHeight: 105,
            //             caption: image.imageCaption,
            //             //thumbnailCaption: image.imageCaption
            //         }
            //     })
            //     setGalleryImages(gallery)
            // }
        }

        if (listing.listingType === 'news' || listing.listingType === 'reviews') {
            if (listing.mypages_content) {
                const con = JSON.parse(listing.mypages_content)
                const contentState = convertFromRaw(con);
                setEditorState(EditorState.createWithContent(contentState))
            }
        }
        if (listing.listingType === 'article' || listing.listingType === 'photos' || listing.listingType === 'album') {
            if (listing.myvideos_content) {
                const con = JSON.parse(listing.myvideos_content)
                const contentState = convertFromRaw(con);
                setEditorState(EditorState.createWithContent(contentState))
            }
        }
    }, [listing])

    function share() {
        const shareButton = document.querySelector('.share-button');
        const shareDialog = document.querySelector('.share-dialog');
        const closeButton = document.querySelector('.close-button');

        shareButton.addEventListener('click', event => {
            if (navigator.share) {
                navigator.share({
                    title: 'WebShare API',
                    url: [shareUrl]
                }).then(() => {
                    console.log('Thanks for sharing!');
                })
                    .catch(console.error);
            } else {
                shareDialog.classList.add('is-open');
            }
        });

        // closeButton.addEventListener('click', event => {
        //     shareDialog.classList.remove('is-open');
        // });
    }

    function copyToClipboard(e) {
        textAreaRef.current.select();
        document.execCommand('copy');
        // This is just personal preference.
        // I prefer to not show the the whole text area selected.
        e.target.focus();
    };

    function copy() {
        const el = document.createElement("input");
        el.value = shareUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        setCopied(true);
    }

    let premiumCol = ['col-md-9'].join(' ');
    let premiumMobileCol = ['col-md-12'].join(' ')
    if (listing.listingType === "business" && (listing.businessPackage === 'premium' || listing.businessPackage === 'advanced')) {
        //premiumCol = ['col-md-9'].join(' ');

        if (listing.galleryImages.length > 4 && document.getElementsByClassName('ReactGridGallery_tile-overlay')[3]) {
            document.getElementsByClassName('ReactGridGallery_tile-overlay')[3].innerHTML = listing.galleryImages.length - 4 + '+';
            document.getElementsByClassName('ReactGridGallery_tile-overlay')[3].className = ('gallery_over_lay');
        }
    }

    if (!listing.hpId)
        return <> </>
    else
        return (
            <>
                {/* <MetaDecor title={listing.businessName} imageURL={listing.thumbnailImage}></MetaDecor> */}
                {//listing.businessPackage !== 'basic' ?
                    <div className={isMobile ? `row ${styles.listingMob}` : "row"}>
                        <div className={isMobile ? premiumMobileCol : premiumCol}>
                            <div className='row'>
                                <div className='col-md-12 share-right'>
                                    <div className='col-md-9 float-left'></div>
                                    <div className='col-md-3 float-right'>
                                        <button className={listing.businessPackage !== 'basic' ? "large_rect share-button adv-btn" : "large_rect share-button"} type="button" title="Share this article" onClick={share}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                                                <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                                            </svg>
                                            <span>Share</span>
                                        </button>
                                        <svg className="hidden">
                                            <defs>
                                                <symbol id="share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-share"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></symbol>
                                                <symbol id="close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-x-square"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></symbol>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            {listing.listingType === "article" || listing.listingType === "news" || listing.listingType === "photos" || listing.listingType === "album" || listing.listingType === "reviews" ?
                                <h1 className="article_header">{listing.businessName}</h1> : <h1 className={isMobile ? "article_header" : styles.single_listing_header}>{listing.businessName}</h1>}
                            {listing.listingType === "article" || listing.listingType === "news" || listing.listingType === "photos" || listing.listingType === "album" || listing.listingType === "reviews" ?
                                <h5 className="review_user publisher"> {`${listing.user.firstName} ${listing.user.lastName}`} &middot; <span> {dateFormator.timeAgo(listing.postedDate)}</span></h5> : null}
                            {listing.businessPackage !== 'basic' && listing.listingType === "business" && props.listingReviewGlance ?
                                <div className={isMobile ? `single_listing_rating ${styles.caption_rating_mob}` : `single_listing_rating ${styles.caption_rating}`}>
                                    <StarRatingComponent
                                        name="app6"
                                        starColor="#138808"
                                        emptyStarColor="#138808"
                                        value={props.listingReviewGlance.averageRating}
                                        editing={false}
                                        renderStarIcon={(index, value) => {
                                            return (
                                                <span>
                                                    <i className={index <= value ? 'fas fa-star' : 'far fa-star'} />
                                                </span>
                                            );
                                        }}
                                        renderStarIconHalf={() => {
                                            return (
                                                <span>
                                                    <span className={styles.span_rating}><i className="far fa-star" /></span>
                                                    <span><i className="fas fa-star-half" /></span>
                                                </span>
                                            );
                                        }} />

                                    <div className="listing_review_count display_inline_block">{props.listingReviewGlance.totalReviews}</div>
                                </div> : null}
                        </div>
                        {!props.isAdmin ?
                            (!isBillboard ?
                                <div className="form-group col-md-3 text-right">
                                    <div className="social_container">
                                        <div className="social_network">
                                            <FacebookShareButton url={shareUrl}
                                                quote={listing.businessName}
                                                className="cursor_pointer">
                                                <FacebookIcon size={32} round={true} />
                                            </FacebookShareButton>
                                        </div>
                                        <div className="social_network">
                                            <TwitterShareButton
                                                url={shareUrl}
                                                media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                quote={listing.businessName}
                                                className="cursor_pointer">
                                                <TwitterIcon
                                                    size={32}
                                                    round />
                                            </TwitterShareButton>
                                        </div>
                                        <div className="social_network">
                                            <LinkedinShareButton
                                                url={shareUrl}
                                                media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                quote={listing.businessName}
                                                className="cursor_pointer">
                                                <LinkedinIcon
                                                    size={32}
                                                    round />
                                            </LinkedinShareButton>
                                        </div>
                                        <div className="social_network">
                                            <WhatsappShareButton
                                                url={shareUrl}
                                                text={listing.businessName}
                                                title={listing.businessName}
                                                className="cursor_pointer">
                                                <WhatsappIcon size={32} round />
                                            </WhatsappShareButton>
                                        </div>
                                        <div className="social_network">
                                            <TelegramShareButton
                                                url={shareUrl}
                                                media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                quote={listing.businessName}
                                                className="cursor_pointer">
                                                <TelegramIcon size={32} round />
                                            </TelegramShareButton>
                                        </div>
                                        <div className="social_network">
                                            <div>
                                                <button className="copy" onClick={copy}><i className="fa fa-copy"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <div className="form-group col-md-3 text-right busin-adv-share">
                                    <div className="share-dialog">
                                        <header>
                                            <button className="close-button" onClick={share}><svg><use href="#close"></use></svg></button>
                                        </header>
                                        <div className="targets">
                                            <div className="social_container">
                                                <div className="social_network">
                                                    <FacebookShareButton url={shareUrl}
                                                        quote={listing.businessName}
                                                        className="cursor_pointer">
                                                        <FacebookIcon size={32} round={true} />
                                                    </FacebookShareButton>
                                                </div>
                                                <div className="social_network">
                                                    <TwitterShareButton
                                                        url={shareUrl}
                                                        media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                        quote={listing.businessName}
                                                        className="cursor_pointer">
                                                        <TwitterIcon
                                                            size={32}
                                                            round />
                                                    </TwitterShareButton>
                                                </div>
                                                <div className="social_network">
                                                    <LinkedinShareButton
                                                        url={shareUrl}
                                                        media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                        quote={listing.businessName}
                                                        className="cursor_pointer">
                                                        <LinkedinIcon
                                                            size={32}
                                                            round />
                                                    </LinkedinShareButton>
                                                </div>
                                                <div className="social_network">
                                                    <WhatsappShareButton
                                                        url={shareUrl}
                                                        title={listing.businessName}
                                                        image={listing.thumbnailImage}
                                                        imageUrl={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                        quote={listing.businessName}
                                                        className="cursor_pointer">
                                                        <WhatsappIcon size={32} round />
                                                    </WhatsappShareButton>
                                                </div>
                                                <div className="social_network">
                                                    <TelegramShareButton
                                                        url={shareUrl}
                                                        media={`${process.env.REACT_APP_IMAGES_URL}${listing.thumbnailImage}`}
                                                        quote={listing.businessName}
                                                        className="cursor_pointer">
                                                        <TelegramIcon size={32} round />
                                                    </TelegramShareButton>
                                                </div>
                                            </div>
                                            <div className="link">
                                                <input className="pen-url"
                                                    ref={textAreaRef}
                                                    value={shareUrl}
                                                />
                                                <button className="copy-link" onClick={copyToClipboard}>Copy</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>) : null}
                    </div>
                }
                {
                    listing.listingType !== 'article' && listing.listingType !== 'news' && listing.listingType !== 'photos' && listing.listingType !== 'album' && listing.listingType !== 'reviews' && listing.businessPackage !== 'basic' ?
                        <div>
                            {listing.specializedIn !== '' && listing.businessPackage === 'premium' ?
                                <div className="row form-row">
                                    <div className="form-group col-md-12">
                                        <h2 className={styles.preview_header}>About the Business</h2>
                                        <div className="rdw-storybook-root">
                                            <Editor
                                                editorState={editorState}
                                                wrapperClassName="rdw-storybook-wrapper"
                                                readOnly
                                                toolbarHidden
                                            />
                                        </div>
                                    </div>
                                </div> :
                                <div className="row form-row">
                                    <div className="form-group col-md-12">
                                        <h2 className={styles.preview_header}>About the {listing.listingType.charAt(0).toUpperCase() + listing.listingType.slice(1)}</h2>
                                        {listing.advance_content !== '' ? <div className={styles.listing_desc}>
                                            <div className="rdw-storybook-root">
                                                <Editor
                                                    editorState={editorState}
                                                    wrapperClassName="rdw-storybook-wrapper"
                                                    readOnly
                                                    toolbarHidden
                                                />
                                            </div>
                                        </div> : <div className="rdw-storybook-root">
                                            <Editor
                                                editorState={editorState}
                                                wrapperClassName="rdw-storybook-wrapper"
                                                readOnly
                                                toolbarHidden
                                            />
                                        </div>}
                                        {listing.specializedIn === '' ? <div className={styles.listing_desc}>{listing.specializedIn}</div> : null}

                                    </div>
                                </div>
                            }
                            {(listing.listingType === 'business') ?
                                <div className="row form-row">
                                    <div className={"form-group display_grid col-md-5"}>
                                        {listing.address.length || listing.emailAddress || listing.website ? <div className="contact_info_box">
                                            {(listing.listingType !== "news" && listing.listingType !== "reviews" && listing.listingType !== "photos" && listing.listingType !== "album" && listing.listingType !== "article" && listing.listingType !== "job" && listing.listingType !== "event") ?
                                                <div>
                                                    {(listing.address.length || listing.emailAddress || listing.website) ?
                                                        <h2 className={styles.preview_header}>Contact Information</h2> : null}
                                                    <div className="row form-row">
                                                        {listing.address.map((item, index) => {
                                                            return (
                                                                <div key={item.id} className="col-md-12">
                                                                    <div className="row">
                                                                        <Labels className="col-md-12">Address{listing.address.length > 1 ? (index + 1) : null}: </Labels>
                                                                    </div>
                                                                    <div className="row form-row">
                                                                        <div className="form-group col-md-12">
                                                                            {item.address}
                                                                        </div>
                                                                    </div>
                                                                    {item.landmark ?
                                                                        <div className="row">
                                                                            <Labels className="col-md-12" text={'Landmark:'} />
                                                                        </div> : null}
                                                                    <div className="row form-row">
                                                                        <div className="form-group col-md-12">{item.landmark}</div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <Labels className="col-md-12" text={'Contact Person Name:'} />
                                                                    </div>
                                                                    <div className="row form-row">
                                                                        <div className="form-group col-md-12">{item.contactPerson}</div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <Labels className="col-md-12" text={'Phone:'} />
                                                                    </div>
                                                                    <div className="row form-row">
                                                                        <div className="form-group col-md-12">{item.contactNumber}</div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div></div> : null}
                                            {listing.emailAddress && listing.listingType === "business" ? <div>
                                                <div className="row">
                                                    <Labels className="col-md-12" text={'Email:'} />
                                                </div>
                                                <div className="row form-row">
                                                    <div className="form-group col-md-12">{listing.emailAddress}</div>
                                                </div>
                                            </div> : null}
                                            {listing.website && listing.listingType === "business" ? <div>
                                                <div className="row">
                                                    <Labels className="col-md-12" text={'Website:'} />
                                                </div>
                                                <div className="row form-row">
                                                    <div className="form-group col-md-12"><a href={`http://${listing.website}`} target='_blank'>{listing.website}</a></div>
                                                    {console.log(listing.website)}
                                                </div>
                                            </div> : null}
                                        </div> : null}
                                    </div>
                                    <div className={isMobile ? "form-group display_grid col-md-5" : "form-group display_grid col-md-3"}>
                                        {listing.openingHoursList.length ?
                                            <div className="working_hours_box">
                                                {listing.openingHoursList.length > 0 ? <div>
                                                    <h2 className={`${styles.preview_header} text-left`}>Working Hours</h2>
                                                    {listing.openingHoursList.map((hours, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <div key={'open' + index} className="row form-row desktop_label">
                                                                    <Labels className="form-group col-md-4">{hours.day}</Labels>
                                                                    <div className="form-group col-md-4 working_hours_inner text-right">
                                                                        {hours.openingTime}
                                                                    </div>
                                                                    <div className="form-group col-md-4 working_hours_inner text-right">
                                                                        {hours.closingTime}
                                                                    </div>
                                                                </div>
                                                                <div key={'close' + index} className="mobile_label">

                                                                    <div className={styles.hour_display}>
                                                                        <Labels className="form-group col-md-1 weeklabel">{hours.day}</Labels>
                                                                        <div className={`form-group col-md-12 ${styles.hour_display}`}>
                                                                            <div className="form-group col-md-6">
                                                                                {hours.openingTime}
                                                                            </div>
                                                                            <div className="form-group col-md-6">
                                                                                {hours.closingTime}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div> : null}
                                            </div> : null}
                                    </div>
                                    <div className="form-group col-md-4 display_grid">
                                        {galleryImages.length ?
                                            <div className={"image_gallery_box"}>
                                                {galleryImages.length > 0 ? <div>
                                                    <h2 className={`${styles.preview_header} text-left`}>Image Gallery</h2>
                                                    <Gallery
                                                        images={galleryImages}
                                                        enableLightbox={true}
                                                        enableImageSelection={false}
                                                        rowHeight={125}
                                                        maxRows={2}
                                                    />
                                                </div> : null}
                                            </div> : null}
                                    </div>
                                </div>
                                : null}
                            {(listing.listingType === 'job' || listing.listingType === 'event') ?
                                <div>
                                    {listing.address.map((item, index) => {
                                        return (
                                            <div key={item.id} className="row form-row">
                                                <div className={isMobile ? "form-group display_grid col-md-5" : "form-group display_grid col-md-3"}>
                                                    {listing.experience || listing.dates.length ?
                                                        <div className="contact_info_box">
                                                            {listing.listingType === "job" ? <div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <h2 className={`${styles.preview_header} text-left`}>Experience</h2></div>
                                                                </div>
                                                                <div className="row form-row">
                                                                    <div className="form-group col-md-12">
                                                                        {listing.experience ? listing.experience : " Not Mentioned"}
                                                                    </div>
                                                                </div>
                                                            </div> : null}
                                                            {listing.dates.length > 0 && (listing.listingType === "event" || listing.listingType === "job") ?
                                                                <div>
                                                                    {/* <h2 className={`${styles.preview_header} text-left`}>
                                                                        {listing.listingType === "job" ? "Interview" : "Event"} Date &amp; Time</h2> */}
                                                                    {listing.dates.map((element, index) => {
                                                                        if (item.address === element.address_text) {
                                                                            return (
                                                                                <div key={index} className="event_job_date">
                                                                                    <div className="row">
                                                                                        <h2 className={`${styles.preview_header} ${styles.preview_header_date} text-right`}>{listing.listingType === "job" ? element.fromTime ? "Interview Date & Time " : 'Last Date To Apply' : listing.listingType === "event" ? element.fromTime ? "Event Date & Time" : "Event Last Date" : null}</h2>
                                                                                        <div className="col-md-12">
                                                                                            {dateFormator.scheduleDate(element.date)}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row form-row">
                                                                                        <div className="form-group col-md-12">
                                                                                            {element.fromTime} {element.fromTime ? "-" : null} {element.toTime}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })}
                                                                </div> : null}
                                                        </div> : null}
                                                </div>
                                                <div className={"form-group display_grid col-md-5"}>
                                                    {(listing.salary || listing.address.length && (listing.listingType === "event" || listing.listingType === "job")) ?
                                                        <div className="working_hours_box">
                                                            {listing.listingType === "job" ? <div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <h2 className={`${styles.preview_header} text-left`}>Salary</h2></div>
                                                                </div>
                                                                <div className="row form-row">
                                                                    <div className="form-group col-md-12">
                                                                        {listing.salary ? listing.salary : " Not Mentioned"}
                                                                    </div>
                                                                </div>
                                                            </div> : null}
                                                            {(listing.address.length && (listing.listingType === "event" || listing.listingType === "job")) ?
                                                                <div>
                                                                    <h2 className={styles.preview_header}>
                                                                        {listing.listingType === "job" ? "Interview" : listing.listingType === "event" ? "Event" : null} Venue
                                                                    </h2>
                                                                    <div className="row form-row">

                                                                        <div className="form-group col-md-12">
                                                                            <div className="row">
                                                                                <Labels className="col-md-12">Address{listing.address.length > 1 ? (index + 1) : null}:</Labels>
                                                                            </div>
                                                                            <div className="row form-row">
                                                                                <div className="form-group col-md-12">{item.address}</div>
                                                                            </div>
                                                                            {item.landmark ?
                                                                                <div className="row">
                                                                                    <Labels className="col-md-12" text={'Landmark:'} />
                                                                                </div> : null}
                                                                            {item.landmark ?
                                                                                <div className="row form-row">
                                                                                    <div className="form-group col-md-12">{item.landmark}</div>
                                                                                </div> : null}
                                                                        </div>

                                                                    </div></div> : null}
                                                        </div> : null}
                                                </div>

                                                <div className="form-group col-md-4 display_grid">
                                                    {listing.listingType === "job" && (item.contactNumber || item.contactPerson || listing.emailAddress || listing.website) ?
                                                        <div className={"image_gallery_box email_website"}>
                                                            <div className="row form-row">
                                                                <div className="col-md-12"><h2 className={styles.preview_header}>Contact Details</h2></div>
                                                            </div>
                                                            {item.contactPerson ? <div>
                                                                <div className="row">
                                                                    <Labels className="col-md-12" text={'Contact Person Name:'} />
                                                                </div>
                                                                <div className="row form-row">
                                                                    <div className="form-group col-md-12">{item.contactPerson}</div>
                                                                </div>
                                                            </div> : null}
                                                            {item.contactNumber ? <div>
                                                                <div className="row">
                                                                    <Labels className="col-md-12" text={'Phone:'} />
                                                                </div>
                                                                <div className="row form-row">
                                                                    <div className="form-group col-md-12">{item.contactNumber}</div>
                                                                </div>
                                                            </div> : null}
                                                            {listing.emailAddress ? <div>
                                                                <div className="row">
                                                                    <Labels className="col-md-12" text={'Email:'} />
                                                                </div>
                                                                <div className="row form-row">
                                                                    <div className="form-group col-md-12">{listing.emailAddress}</div>
                                                                </div>
                                                            </div> : null}
                                                            {listing.website && listing.listingType === "job" ?
                                                                <div>
                                                                    <div className="row">
                                                                        <Labels className="col-md-12" text={'Website:'} />
                                                                    </div>
                                                                    <div className="row form-row">
                                                                        <div className="form-group col-md-12"><a href={`http://${listing.website}`} target='_blank'>{listing.website}</a></div>
                                                                        {console.log(listing.website)}
                                                                    </div>
                                                                </div> : null}
                                                        </div> : null}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div> : null}
                        </div> : null
                }
                <div>

                    {(listing.listingType === 'business') && (listing.businessPackage === "basic") ?
                        <div className="row" style={{ marginLeft: '15px' }}>
                            <div className="col-md-12 form-group">
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <h2 className={styles.preview_header}>About the {listing.listingType.charAt(0).toUpperCase() + listing.listingType.slice(1)}</h2>
                                        <div className={`${styles.listing_preview_basic}`}>
                                            <div className={styles.image_container}>
                                                <img className={`img_fluid ${styles.thumb_image}`} loading='lazy'
                                                    src={process.env.REACT_APP_IMAGES_URL + listing.thumbnailImage} />
                                            </div>
                                            <div className={`${styles.listing_desc} ${styles.listing_wordBreak}`}>
                                                {listing.specializedIn}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {listing.address.length ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h2 className={styles.preview_header}>Contact Information</h2>
                                        </div>
                                    </div> : null}
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="row form-row">
                                            {listing.address.length ?
                                                <div className="col-md-6 form-group">
                                                    <Labels text={'Address:'} />
                                                    <div>{listing.address[0].address}</div>
                                                </div> : null}
                                            {listing.contactPerson ?
                                                <div className="col-md-6 form-group">
                                                    <Labels text={'Contact Person Name:'} />
                                                    <div>{listing.contactPerson}</div>
                                                </div> : null}
                                            {listing.address.length ?
                                                <div className="col-md-6 form-group">
                                                    {listing.address[0].landmark ?
                                                        <Labels text={'Landmark'} /> : null}
                                                    <div>{listing.address[0].landmark}</div>
                                                </div> : null}
                                            {listing.contactNumber ?
                                                <div className="col-md-6 form-group">
                                                    <Labels text={'Phone:'} />
                                                    <div>{listing.contactNumber}</div>
                                                </div> : null}

                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row form-row">
                                            {listing.emailAddress ?
                                                <div className="col-md-12 form-group">
                                                    <Labels text={'Email:'} />
                                                    <div>{listing.emailAddress}</div>
                                                </div> : null}
                                            {listing.website ?
                                                <div className="col-md-12 form-group">
                                                    <Labels text={'Website:'} />
                                                    <div><a href={`http://${listing.website}`} target='_blank'>{listing.website}</a></div>
                                                    {console.log(listing.website)}
                                                </div> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : (listing.listingType === 'job' || listing.listingType === 'event') && (listing.businessPackage === "basic") ?
                            <div style={{ marginLeft: '15px' }}>
                                <div className="row form-row">
                                    <div className="col-md-12 form-group">
                                    </div>
                                    <div className="row form-row">
                                        <div className="form-group col-md-12">
                                            <h2 className={styles.preview_header_event}>About the {listing.listingType.charAt(0).toUpperCase() + listing.listingType.slice(1)}</h2>
                                            <div className={`${styles.listing_preview_basic}`}>
                                                <div className={styles.image_container_event}>
                                                    <img className={`img_fluid ${styles.thumb_image}`} loading='lazy'
                                                        src={process.env.REACT_APP_IMAGES_URL + listing.thumbnailImage} />
                                                </div>
                                                <div className={`${styles.listing_desc} ${styles.listing_wordBreak}`}>
                                                    {listing.specializedIn}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {listing.experience && listing.listingType === "job" ?
                                            <div>
                                                <h2 className={styles.preview_header}>Experience</h2>

                                                <p>{listing.experience}</p>
                                            </div> : null}

                                        {
                                            (listing.dates && listing.dates.length > 0) ?
                                                <div className="">
                                                    <h2 className={styles.preview_header}>{listing.listingType === "job" ? listing.dates[0].fromTime ? "Interview Date & Time" : "Last Date To Apply" : listing.listingType === "event" ? listing.dates[0].fromTime ? "Event Date & Time" : "Event Last Date" : null}</h2>
                                                    {listing.dates.sort((a, b) => {
                                                        const aTimeStamp = moment(a.date + " " + a.fromTime, 'DD/MM/YYYY hh:mm a')
                                                        const bTimeStamp = moment(b.date + " " + b.fromTime, 'DD/MM/YYYY hh:mm a')
                                                        const re = aTimeStamp > bTimeStamp ? 1 : aTimeStamp < bTimeStamp ? -1 : 0;
                                                        return re
                                                    }).map((element, index) => (
                                                        <div key={index}>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {dateFormator.scheduleDate(element.date)}
                                                                </div>
                                                            </div>
                                                            <div className="row form-row">
                                                                <div className="form-group col-md-12">
                                                                    {element.fromTime} {element.fromTime ? "-" : null} {element.toTime}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : null}
                                        {listing.address.map((item, index) =>
                                            <div className="basic_address" key={index}>
                                                <div className="divide_labels">
                                                    <h2 className={`${styles.preview_header}`}>Venue{listing.address.length > 1 ? (index + 1) : null}</h2>
                                                    <div>{item.address}</div>
                                                </div>
                                                {item.landmark ?
                                                    <div className="divide_labels">
                                                        <Labels text={'Landmark:'} />
                                                        <div>{item.landmark}</div>
                                                    </div> : null}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        {listing.salary && listing.listingType === "job" ?
                                            <div className="">
                                                <h2 className={styles.preview_header}>Salary</h2>
                                                <p>{listing.salary}</p>
                                            </div> : null}
                                        {listing.contactPerson || listing.contactNumber || listing.companyName ?
                                            <div className="">
                                                <h2 className={styles.preview_header}>Contact Information</h2>
                                                {listing.companyName && listing.listingType === "job" ?
                                                    <div className="divide_labels">
                                                        <Labels text={'Company Name:'} />
                                                        <div>{listing.companyName}</div>
                                                    </div> : null}
                                            </div> : null}

                                        <div className="basic_address">
                                            {listing.contactPerson ?
                                                <div className="divide_labels">
                                                    <Labels text={'Contact Person:'} />
                                                    <div>{listing.contactPerson}</div>
                                                </div> : null}
                                            {listing.contactNumber ?
                                                <div className="divide_labels">
                                                    <Labels text={'Phone:'} />
                                                    <div>{listing.contactNumber}</div>
                                                </div> : null}

                                        </div>

                                        {listing.emailAddress ?
                                            <div className="divide_labels">
                                                <Labels text={'Email:'} />
                                                <div>{listing.emailAddress}</div>
                                            </div> : null}
                                        {listing.website ?
                                            <div className="divide_labels">
                                                <Labels text={'Website:'} />
                                                <a href={`http://${listing.website}`} target='_blank'><div>{listing.website}</div></a>
                                                {console.log(listing.website)}
                                            </div> : null}

                                    </div>
                                </div>

                            </div> : null}
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        {listing.myvideos_content !== '' && listing.listingType === 'photos' || listing.myvideos_content !== '' && listing.listingType === 'album' ?
                            <div className="rdw-storybook-root">
                                <Editor
                                    editorState={editorState}
                                    wrapperClassName="rdw-storybook-wrapper"
                                    readOnly
                                    toolbarHidden
                                />
                            </div> : null}
                        {listing.elements.length ?
                            <div>
                                {listing.elements.map((element, index) => (
                                    <div className={styles.article_data} key={element.id}>
                                        {element.type === 'text' ?
                                            <h2 className={isMobile ? `${styles.article_data_mob_h2}` : `${styles.article_data_h2}`}>{element.value}</h2>
                                            : element.type === 'textarea' ?
                                                <div className={styles.article_data_listing_desc}>{element.value}</div>
                                                : element.type === 'image' ?
                                                    <div className={isMobile ? 'article_img_tag_mob' : 'article_img_tag'}>
                                                        <img className={isMobile ? `img-fluid ${styles.article_image_mob}` : `img-fluid ${styles.article_image}`} src={process.env.REACT_APP_IMAGES_URL + element.value} />
                                                        <h3 className={styles.listing_desc_article_image}>{element.tagLine}</h3>
                                                    </div>
                                                    : element.type === 'video' ?
                                                        <div className={isMobile ? 'article_img_tag_mob' : 'article_img_tag'}>
                                                            <video id='video' className={isMobile ? `${styles.article_video_mob}` : `${styles.article_video}`} ref={videoRef} autoplay oncontextmenu="return false;" controlsList="nodownload nopictureinpicture noremoteplayback" controls src={process.env.REACT_APP_IMAGES_URL + element.value} />
                                                            <h3 className={styles.listing_desc_article_image}>{element.tagLine}</h3>
                                                        </div> :
                                                        <div>{listing.myvideos_content !== '' && listing.listingType === 'article' ?
                                                            <div className="rdw-storybook-root">
                                                                <Editor
                                                                    editorState={editorState}
                                                                    wrapperClassName="rdw-storybook-wrapper"
                                                                    readOnly
                                                                    toolbarHidden
                                                                />
                                                            </div> : null}</div>
                                        }
                                    </div>
                                ))}

                            </div> : <div>
                                {(listing.mypages_content !== '' && listing.listingType === 'news') || (listing.mypages_content !== '' && listing.listingType === 'reviews') ?
                                    <div className="rdw-storybook-root">
                                        <Editor
                                            editorState={editorState}
                                            wrapperClassName="rdw-storybook-wrapper"
                                            readOnly
                                            toolbarHidden
                                        />
                                    </div> : null}
                            </div>}
                    </div>
                </div>

                {
                    ((listing.businessPackage === 'advanced' || listing.businessPackage === 'premium') && listing.address.length > 0 && !mapVisible)
                    && <LinkButton handleClick={() => setMapVisible(mapVisible => !mapVisible)} text='Show on map' />
                }
                {
                    mapVisible &&
                    <div>
                        <h2 className={styles.preview_header}>{listing.listingType === "job" ? "Interview" : listing.listingType === "event" ? "Event" : null} Location Map</h2>
                        <MapContainer listing={listing} />
                    </div>
                }

                {
                    (listing.listingType === "job" && listing.companyName && listing.companyDescription ?
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className={`${styles.preview_header} text-left`}>{"About " + listing.companyName}</h2>
                            </div>
                            <div className="form-group col-md-12">
                                {listing.companyDescription}
                            </div>

                        </div> : null)
                }
                {
                    listing.listingType === "event" ?
                        <div className="row addpost_section">
                            {listing.organizerName ?
                                <div className="col-md-12"><h2 className={styles.preview_header}>Organized By {listing.organizerName}</h2></div>
                                : null}

                        </div> : null
                }
                <div className="row">

                    <div className="col-md-4">
                        {listing.organizerAddress ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Address:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerAddress}
                            </div>
                        </div>
                        {listing.organizerLandmark ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Landmark:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerLandmark}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        {listing.organizerPerson ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Contact Person Name:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerPerson}
                            </div>
                        </div>
                        {listing.organizerPhone ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Phone:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerPhone}
                            </div>
                        </div>

                    </div>

                    <div className="col-md-4">
                        {listing.organizerEmail ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Email:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerEmail}
                            </div>
                        </div>
                        {listing.organizerWebsite ?
                            <div className="row">
                                <Labels className="col-md-12" text={'Website:'} />
                            </div> : null}
                        <div className="row form-row">
                            <div className="form-group col-md-12">
                                {listing.organizerWebsite}
                            </div>
                        </div>
                    </div>

                </div>
            </>

        )
}